// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__25gqQ","inputDescription":"styles_inputDescription__U00yK"};